import React from 'react';
// import { getStyle } from '../../components';
import { observer } from 'mobx-react';
import './SwiperItem.less';
import Swiper from '../../com/swiper-3.3.1.min';
import '../../com/swiper-3.3.1.min.css';

@observer
class SwiperItem extends React.Component<any, any> {
    private swipperDOM: HTMLElement;

    private refMap = {
        swipperDOM: (obj) => this.swipperDOM = obj,
    };

    static defaultProps = {
        prefixCls: 'swiper-item',
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            data: this.props.data
        };
    }

    swiper: any;

    componentDidMount() {
        this.swiper = new Swiper(this.swipperDOM, {
            slidesPerView: 'auto',
            freeMode: true,
            freeModeMomentum: false,
        });
    }

    render() {
        const {prefixCls, data} = this.props;
        return <div className={`${prefixCls}container`}>
            <div className="swiper-container" ref={this.refMap.swipperDOM}>
                <div className="swiper-wrapper">
                    {data && data.map((value, index) => {
                        return <div className={`swiper-slide ${prefixCls}goods`} key={index}>
                            <div className={`${prefixCls}imgBox`}>
                                <div>
                                    <img src={value.productImage}/>
                                </div>
                            </div>
                            <span className={`${prefixCls}numbers`}><i>x</i>{value.num}</span>
                        </div>;
                    })}
                </div>
            </div>
        </div>;
    }
}

export default SwiperItem;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/SwiperItem.tsx